<template>
    <div class="container-fluid" id="dvcrud">
        <div class="row">
            <div class="col-md-12">
                <breadcrumb v-bind:bcitens="itensbc" v-bind:mtdcancelar="mtdcancelaredicao"></breadcrumb>
            </div>
            <div class="col-md-12">
                <div id="pnlista" class="card" style="display: none;">
                    <div class="card-header"><span id="titlista">LISTAGEM DE {{ itensbc.item1.titulo }}</span>
                        <router-link to="/">
                            <button type="button" class="close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">&times;</span></button>
                        </router-link>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close" title="Monitoramento de atividades de usuários" style="margin-right: 10px;" @click.prevent="mtdmonitoramento()"><span aria-hidden="true"><i class="fa fa-video-camera"></i></span></button>                                                
                    </div>
                    <div class="card-body" style="padding: 10px;">
                        <div class="row">
                            <div class="col-sm-4 col-md-2 col-lg-2">
                                <label for="cbopfiltro">Filtrar:</label>
                                <select name="cbopfiltro" class="form-control form-control-sm" id="cbopfiltro" v-model="pfiltro" @change="mtdlimpar_listagem()">
                                    <option value="0">Código</option>
                                    <option value="1">Nome</option>
                                </select>
                            </div>
                            <div class="col-sm-6 col-md-4 col-lg-4">
                                <label for="edconteudopesq">Conteúdo da pesquisa:</label>
                                <input id="edconteudopesq" type="text" class="form-control form-control-sm" v-model="pconteudo" @keyup="mtdlimpar_listagem()">
                            </div>
                            <div class="col-sm-12 col-md-2 col-lg-2">
                                <label for="cbativopesq">Situação:</label>
                                <select name="cbativopesq" class="form-control form-control-sm" id="cbativopesq" v-model="pativo" @change="mtdlimpar_listagem()">
                                    <option value="0">Inativos</option>
                                    <option value="1">Ativos</option>
                                    <option value="2">Todos</option>
                                </select>
                            </div>                             
                            <div class="col-6 col-sm-6 col-md-2 col-lg-2">
                                <label for="cbqtdreg">Registros:</label>
                                <select name="cbqtdreg" class="form-control form-control-sm" id="cbqtdreg" v-model="pqtdregistros" @change="mtdlimpar_listagem()">
                                    <option value="10">10</option>
                                    <option value="20">20</option>
                                    <option value="30">30</option>
                                    <option value="40">40</option>
                                    <option value="50">50</option>
                                    <option value="99999999999">Todos</option>
                                </select>
                            </div>
                            <div class="col-6 col-sm-6 col-md-2 col-lg-2">
                                <button type="button" id="btlistar" class="btn btn-primary btn-sm btn-block" @click.prevent="mtdexecutapesquisa()"><i class="fa fa-search"></i> Listar</button>
                            </div>
                            <div class="col-md-12" style="margin-top: 10px;">
                                <vue-bootstrap4-table
                                        :rows="lstusuarios"
                                        :columns="columns"
                                        :config="config"
                                        :classes="classes">
                                    <template slot="empty-results">
                                        <div class="col-md-12 text-center">Sem dados para visualização</div>
                                    </template>
                                    <!-- ícones de ordenação da table -->
                                    <template slot="sort-asc-icon">
                                        <i class="fa-icones-ordenacao fa fa-sort-asc"></i>
                                    </template>
                                    <template slot="sort-desc-icon">
                                        <i class="fa-icones-ordenacao fa fa-sort-desc"></i>
                                    </template>
                                    <template slot="no-sort-icon">
                                        <i class="fa-icones-ordenacao fa fa-unsorted"></i>
                                    </template>                                    
                                    <!--  -->                                    
                                    <template slot="codusu_f" slot-scope="item">
                                        {{ item.row.codusu }}
                                    </template>
                                    <template slot="slot_situacao" slot-scope="item">
                                        <span v-if="parseInt(item.row.ativo) === 1" class="badge badge-pill badge-success">Ativo</span>
                                        <span v-else class="badge badge-pill badge-danger">Inativo</span>
                                    </template>                                    
                                    <template slot="opcoes" slot-scope="item">
                                        <button type="button" class="btn btn-info btn-sm btn-opcrud ajt-btn" @click.prevent="mtdalterar(item.row)"><i class="fa fa-edit"></i></button>
                                        <button type="button" class="btn btn-danger btn-sm btn-opcrud ajt-btn" @click.prevent="mtdexcluir(item.row)"><i class="fa fa-trash"></i></button>
                                    </template>
                                </vue-bootstrap4-table>
                            </div>
                            <div class="col-md-12">
                                <ul class="list-group">
                                    <li class="list-group-item d-flex justify-content-between align-items-center" style="padding: 10px;">
                                        Registros
                                        <span class="badge badge-info badge-pill text-right bdg-qtd-reg-info">{{lstusuarios.length}}</span>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                    <div class="card-footer" style="padding: 10px;">
                        <div class="row">
                            <div class="col-8 col-sm-8 col-md-10 col-lg-10" id="dvpaginacao">
                                <v-pagination
                                        v-model="pagina_atual"
                                        :page-count="pqtd_paginas"
                                        :classes="bootstrapPaginationClasses">
                                </v-pagination>
                            </div>
                            <div class="col-4 col-sm-4 col-md-2 col-lg-2">
                                <button type="button" class="btn btn-success btn-sm btn-block" @click.prevent="mtdnovo()"><i class="fa fa-file"></i> Novo</button>
                            </div>
                        </div>
                    </div>
                </div>
                <div id="pncadastro" class="card" style="display:none;">
                    <div class="card-header"><span>{{itensbc.item2.titulo}}</span>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close" @click.prevent="mtdcancelaredicao()"><span aria-hidden="true">&times;</span></button>
                    </div>
                    <div class="card-body">
                        <div class="row">
                            <div class="col-md-10">
                                <div class="row">
                                    <div class="col-sm-12 col-md-2 col-lg-2">
                                        <label for="edid">Código:</label>
                                        <input type="text" class="form-control form-control-sm" id="edid" v-model="vcodusu"
                                            maxlength="20" style="text-transform: uppercase;" disabled/>
                                    </div>
                                    <div class="col-sm-12 col-md-5 col-lg-5">
                                        <label for="ednome">*Nome do usuário:</label>
                                        <input type="text" v-model="vnomeusu" v-bind:disabled="ativadesativa"
                                            class="form-control form-control-sm" id="ednome" maxlength="50">
                                    </div>
                                    <div class="col-sm-12 col-md-3 col-lg-3">
                                        <label for="edlogin">*Login:</label>
                                        <input type="text" v-model="vloginusu" v-bind:disabled="opcrud > 1"
                                            class="form-control form-control-sm" id="edlogin" data-bv-group=".group" maxlength="20"
                                            style="text-transform: lowercase;">
                                    </div>
                                    <div class="col-sm-12 col-md-2 col-lg-2">
                                        <label for="edsenhausu">*Senha:</label>
                                        <input type="password" v-model="vsenhausu" v-bind:disabled="ativadesativa"
                                            class="form-control form-control-sm" id="edsenhausu" data-bv-group=".group" maxlength="20" autocomplete="off">
                                    </div>
                                    <div class="col-sm-12 col-md-4 col-lg-4">
                                        <span class="lblselect2">*Filial padrão:</span>
                                        <select id="cbfilial" v-model="vcodfil" v-bind:disabled="ativadesativa"
                                                data-placeholder="Selecione uma opção" data-allow-clear="true" style="width:100%;">
                                        </select>
                                    </div>                                    
                                    <div class="col-sm-12 col-md-4 col-lg-4">
                                        <span class="lblselect2">*Grupo:</span>
                                        <select id="cbgrupo" v-model="vidgrupo" v-bind:disabled="ativadesativa"
                                                data-placeholder="Selecione uma grupo" data-allow-clear="true" style="width:100%;">
                                        </select>
                                    </div>
                                    <div class="col-sm-12 col-md-4 col-lg-4">
                                        <span class="lblselect2">*Vendedor:</span>
                                        <select id="cbvendedor" v-model="vidvendedor" v-bind:disabled="ativadesativa"
                                                data-placeholder="Selecione um vendedor" data-allow-clear="true" style="width:100%;">
                                        </select>
                                    </div>                                    
                                    <div class="col-sm-12 col-md-4 col-lg-4">
                                        <label for="edemailusu">*E-mail:</label>
                                        <input type="email" v-model="vemailusu" v-bind:disabled="ativadesativa"
                                            class="form-control form-control-sm" id="edemailusu" data-bv-group=".group" maxlength="100">
                                    </div>
                                    <div class="col-sm-12 col-md-2 col-lg-2">
                                        <label for="cbdefinirsenhalogin">Definir senha ao logar:</label>
                                        <select class="form-control form-control-sm" id="cbdefinirsenhalogin" v-model="vdefinirsenhalogin"
                                                v-bind:disabled="ativadesativa">
                                            <option value="0">Não</option>
                                            <option value="1">Sim</option>
                                        </select>
                                    </div>
                                    <div class="col-sm-12 col-md-2 col-lg-2" style="margin-bottom: 15px;">
                                        <label for="cbestoquegeral">Estoque geral:</label>
                                        <select class="form-control form-control-sm" id="cbestoquegeral" v-model="vestoquegeralconsultas" title="Esta opção mostrará a soma dos saldos dos estoques na tela inicial das consultas de produtos. Está opção pode deixar o sistema um pouco lento ao executar as pesquisas."
                                                v-bind:disabled="ativadesativa">
                                            <option value="0">Não</option>
                                            <option value="1">Sim</option>
                                        </select>
                                    </div>                                    
                                    <div class="col-sm-12 col-md-2 col-lg-2" style="margin-bottom: 15px;">
                                        <label for="cbativo">Ativo:</label>
                                        <select class="form-control form-control-sm" id="cbativo" v-model="vativo"
                                                v-bind:disabled="ativadesativa">
                                            <option value="0">Não</option>
                                            <option value="1">Sim</option>
                                        </select>
                                    </div>
                                </div>
                            </div>
                            <div class="col-md-2">
                                <div class="row text-center" style="padding: 0px 15px 0px 15px; margin-bottom: 15px;">
                                    <div class="col-md-12 border rounded" style="padding: 0px;">
                                        <input
                                            type="file" 
                                            id="ipselecionarimgusuario"
                                            accept="image/png, image/jpeg" 
                                            @change="mtdselecionarimagemusuario" 
                                            style="display: none;"
                                            ref="if_imgusuario">
                                        <button v-if="parseInt(opcrud) < 3" type="button" class="btn btn-danger btn-sm btn-del-imgusuario" @click.prevent="mtdexcluirimgusuario()"><i class="fa fa-trash"></i></button>
                                        <img v-if="parseInt(opcrud) < 3" @click="$refs.if_imgusuario.click()" class="img-fluid img-usuario" title="Clique aqui para selecionar uma imagen" v-bind:src="pathimagemvisualizar"> 
                                        <img v-else class="img-fluid img-usuario" v-bind:src="pathimagemvisualizar">                                         
                                    </div>
                                </div>
                            </div>
                            <div class="col-md-12" v-if="opcrud > 0">
                                <ul class="nav nav-tabs" id="myTab" role="tablist">
                                    <li class="nav-item">
                                        <a class="nav-link active" id="tabperfil" data-toggle="tab" href="#dvperfil" role="tab" aria-controls="Perfil do usuário" aria-selected="true">Perfil do usuário</a>
                                    </li>
                                    <li class="nav-item">
                                        <a class="nav-link" id="tabpermissoes" data-toggle="tab" href="#dvpermissoes" role="tab" aria-controls="Filiais" aria-selected="false">Permissões</a>
                                    </li>                                    
                                    <li class="nav-item">
                                        <a class="nav-link" id="tabfiliais" data-toggle="tab" href="#dvfiliais" role="tab" aria-controls="Filiais" aria-selected="false">Filiais do usuário</a>
                                    </li>
                                    <li class="nav-item">
                                        <a class="nav-link" id="tabcards" data-toggle="tab" href="#dvcards" role="tab" aria-controls="Cards" aria-selected="false">Cards</a>
                                    </li>                                    
                                    <li class="nav-item">
                                        <a class="nav-link" id="tabcards" data-toggle="tab" href="#dvvendaexterna" role="tab" aria-controls="Cards" aria-selected="false">Venda externa</a>
                                    </li>                                    
                                </ul>
                                <div class="tab-content border-left border-right border-bottom" id="dvconteudotab" style="padding-top: 15px; padding-bottom: 15px;">
                                    <div class="tab-pane container-fluid fade show active" id="dvperfil" role="tabpanel" aria-labelledby="peril-tab">
                                        <div class="row">
                                            <div class="col-md-12">
                                                <ul class="list-group">
                                                    <li class="list-group-item text-center text-black-50" style="padding: 5px;">
                                                        <span style="font-size: 16px; font-weight: 600;">OPÇÕES DO PERFIL</span>
                                                        <i v-show="parseInt(opcrud) < 3" class="fa fa-clone" id="btclonarperfilusuario" @click.prevent="mtdchamarcopiarperfil()" data-toggle="tooltip" title="Clonar o perfil de um usuário"></i>
                                                        <i v-show="parseInt(opcrud) < 3" class="fa fa-th-list" id="btmarcartodosopusuario" @click.prevent="mtdmarcartodosopcoesusuario()" data-toggle="tooltip" title="Marcar/Desmarcar todas as opções"></i>
                                                    </li>
                                                    <template v-for="(opcao, index) in lstMenuUsuario">
                                                        <li v-if="opcao.descricao !== '-'" v-bind:key="index" @click.prevent="mtdhabilitaop(index)" class="list-group-item d-flex justify-content-between align-items-center item-op-usuario" style="padding: 5px 15px 5px 15px;">
                                                            <span v-bind:class="opcao.classe">{{ opcao.descricao }}</span>
                                                            <span v-if="parseInt(opcao.habilita) === 0"><i class="fa fa-square-o" style="font-size:18px; color: rgba(0,0,0,.65); font-weight: bold; cursor: pointer;"></i></span>
                                                            <span v-else><i class="fa fa-check-square-o" style="font-size:18px; color: rgba(0,0,0,.65); font-weight: bold; cursor: pointer;"></i></span>
                                                        </li>
                                                    </template>
                                                </ul>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="tab-pane fade container-fluid" id="dvpermissoes" role="tabpanel" aria-labelledby="permissoes-tab">
                                        <div class="row">
                                            <div class="col-sm-12 col-md-2 col-lg-2">
                                                <label for="eddescontoprodutos">Desc. produtos à vista(%):</label>
                                                <money class="form-control form-control-sm" id="eddescontoprodutos" v-bind:disabled="ativadesativa" 
                                                       v-bind="money" v-model="vdescontoprodutos" data-bv-group=".group" style="text-align:right;"></money>
                                            </div>
                                            <div class="col-sm-12 col-md-2 col-lg-2">
                                                <label for="eddescontoprodutosprazo">Desc. produtos à prazo(%):</label>
                                                <money class="form-control form-control-sm" id="eddescontoprodutosprazo" v-bind:disabled="ativadesativa" 
                                                       v-bind="money" v-model="vdescontoprodutosprazo" data-bv-group=".group" style="text-align:right;"></money>
                                            </div>                                            
                                            <div class="col-sm-12 col-md-2 col-lg-2">
                                                <label for="eddescontoservicos">Desconto serviços(%):</label>
                                                <money class="form-control form-control-sm" id="eddescontoservicos" v-bind:disabled="ativadesativa" 
                                                       v-bind="money" v-model="vdescontoservicos" data-bv-group=".group" style="text-align:right;"></money>
                                            </div>
                                            <div class="col-sm-12 col-md-2 col-lg-2">
                                                <label for="eddescontojuros">Desconto juros(%):</label>
                                                <money class="form-control form-control-sm" id="eddescontojuros" v-bind:disabled="ativadesativa" 
                                                       v-bind="money" v-model="vdescontojuros" data-bv-group=".group" style="text-align:right;"></money>
                                            </div>
                                            <div class="col-sm-12 col-md-2 col-lg-2">
                                                <label for="eddescontomulta">Desconto multa(%):</label>
                                                <money class="form-control form-control-sm" id="eddescontomulta" v-bind:disabled="ativadesativa" 
                                                       v-bind="money" v-model="vdescontomulta" data-bv-group=".group" style="text-align:right;"></money>
                                            </div>                                                                                        
                                            <div class="col-sm-12 col-md-2 col-lg-2">
                                                <label for="edlimitecreditoautorizar">Crédito liberar:</label>
                                                <money class="form-control form-control-sm" id="edlimitecreditoautorizar" v-bind:disabled="ativadesativa" 
                                                       v-bind="money" v-model="vlimitecreditoautorizar" data-bv-group=".group" style="text-align:right;" title="Limite máximo de crédito a liberar para clientes"></money>
                                            </div>                                                                               
                                        </div>
                                    </div>                                    
                                    <div class="tab-pane fade container-fluid" id="dvfiliais" role="tabpanel" aria-labelledby="filiais-tab">
                                        <div class="row">
                                            <div class="col-sm-12 col-md-4 col-lg-4">
                                                <label for="cbtodasfiliais">Acessar todas as filiais:</label>
                                                <select class="form-control form-control-sm" id="cbtodasfiliais" v-model="vtodasfiliais"
                                                        v-bind:disabled="ativadesativa">
                                                    <option value="0">Não</option>
                                                    <option value="1">Sim</option>
                                                </select>
                                            </div>
                                            <div v-if="parseInt(vtodasfiliais) === 0" class="col-md-12" style="margin-top: 15px;">
                                                <ul class="list-group">
                                                    <li class="list-group-item text-center text-black-50" style="padding: 5px;">
                                                        <span style="font-size: 16px; font-weight: 600;">OPÇÕES DAS FILIAIS</span>
                                                        <i v-show="opcrud < 3" class="fa fa-th-list" id="btmarcartodfiliais" @click.prevent="mtdmarcartodasfiliais()" data-toggle="tooltip" title="Marcar/Desmarcar todas as filiais"></i>
                                                    </li>
                                                    <li v-for="(filial, index) in lstFiliais" @click.prevent="mtdhabilitafilial(index)" v-bind:key="index" class="list-group-item d-flex justify-content-between align-items-center item-op-usuario" style="padding: 5px 15px 5px 15px;">
                                                        <span class="menuprincipal">{{ filial.fantasia }}</span>
                                                        <span v-if="parseInt(filial.habilita) === 0"><i class="fa fa-square-o" style="font-size:18px; color: rgba(0,0,0,.65); font-weight: bold; cursor: pointer;"></i></span>
                                                        <span v-else><i class="fa fa-check-square-o" style="font-size:18px; color: rgba(0,0,0,.65); font-weight: bold; cursor: pointer;"></i></span>
                                                    </li>
                                                </ul>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="tab-pane fade container-fluid" id="dvcards" role="tabpanel" aria-labelledby="cards-tab">
                                        <div class="row">
                                            <div class="col-sm-12 col-md-2 col-lg-2">
                                                <div class="custom-control custom-switch" >
                                                    <input type="checkbox" class="custom-control-input" id="cbcardresumopedidos" v-model="vcardresumopedidos"  v-bind:disabled="ativadesativa">
                                                    <label class="custom-control-label" for="cbcardresumopedidos" id="lblgrafped" >Info pedidos</label>
                                                </div>
                                            </div>
                                            <div class="col-sm-12 col-md-2 col-lg-2">
                                                <div class="custom-control custom-switch" >
                                                    <input type="checkbox" class="custom-control-input" id="cbcardfinanceiro" v-model="vcardfinanceiro"  v-bind:disabled="ativadesativa">
                                                    <label class="custom-control-label" for="cbcardfinanceiro" id="lbldemfin" >Balanço financeiro</label>
                                                </div>
                                            </div>
                                            <div class="col-sm-12 col-md-2 col-lg-2">
                                                <div class="custom-control custom-switch" >
                                                    <input type="checkbox" class="custom-control-input" id="cbcardrecursos" v-model="vcardrecursos"  v-bind:disabled="ativadesativa">
                                                    <label class="custom-control-label" for="cbcardrecursos" id="lblrecurso" >Recursos finaceeiros</label>
                                                </div>
                                            </div>
                                            <div class="col-sm-12 col-md-2 col-lg-2">
                                                <div class="custom-control custom-switch" >
                                                    <input type="checkbox" class="custom-control-input" id="cbcardvendedores" v-model="vcardvendedores"  v-bind:disabled="ativadesativa">
                                                    <label class="custom-control-label" for="cbcardvendedores" id="lbldeve" >Info vendedores</label>
                                                </div>
                                            </div>   
                                            <div class="col-sm-12 col-md-2 col-lg-2">
                                                <div class="custom-control custom-switch" >
                                                    <input type="checkbox" class="custom-control-input" id="cbcardcompra" v-model="vcardcompra"  v-bind:disabled="ativadesativa">
                                                    <label class="custom-control-label" for="cbcardcompra" id="lblcompra" >Faturamento diário</label>
                                                </div>
                                            </div>                                                                                      
                                        </div>
                                    </div>
                                    <div class="tab-pane fade container-fluid" id="dvvendaexterna" role="tabpanel" aria-labelledby="cards-tab">
                                        <div class="row">
                                            <div class="col-6">
                                                <div class="custom-control custom-switch border rounded" style="margin-top: 10px;padding: 5px;">
                                                    <input type="checkbox" class="custom-control-input" id="cbvendaexterna" v-model="vsalesagent">
                                                    <label class="custom-control-label" for="cbvendaexterna" id="lblentregar" style="margin-left: 40px;">Habilitar</label>
                                                </div>                                                
                                            </div>                                            
                                            <div class="col-6">
                                                <div class="custom-control custom-switch border rounded" style="margin-top: 10px;padding: 5px;">
                                                    <input type="checkbox" class="custom-control-input" id="cbclientesvendedor" v-model="vclientesvendedor">
                                                    <label class="custom-control-label" for="cbclientesvendedor" id="lblentregar" style="margin-left: 40px;">Visualizar somente clientes do vendedor</label>
                                                </div>                                                
                                            </div>
                                            <div class="col-md-12" style="margin-top: 15px;">
                                                <ul class="list-group">
                                                    <li class="list-group-item text-center text-black-50" style="padding: 5px;">
                                                        <span style="font-size: 16px; font-weight: 600;">TABELAS DISPONÍVEIS PARA VENDA EXTERNA</span>
                                                        <i v-show="opcrud < 3" class="fa fa-th-list" id="btmarcartodfiliais" @click.prevent="mtdmarcartodastabelas()" data-toggle="tooltip" title="Marcar/Desmarcar todas as tabelas"></i>
                                                    </li>
                                                    <li v-for="(tabela, index) in lsttabelasve" @click.prevent="mtdhabilitatabela(index)" v-bind:key="index" class="list-group-item d-flex justify-content-between align-items-center item-op-usuario" style="padding: 5px 15px 5px 15px;">
                                                        <span class="menuprincipal">{{ tabela.descricao }}</span>
                                                        <span v-if="parseInt(tabela.habilita) === 0"><i class="fa fa-square-o" style="font-size:18px; color: rgba(0,0,0,.65); font-weight: bold; cursor: pointer;"></i></span>
                                                        <span v-else><i class="fa fa-check-square-o" style="font-size:18px; color: rgba(0,0,0,.65); font-weight: bold; cursor: pointer;"></i></span>
                                                    </li>
                                                </ul>
                                            </div>                                            
                                        </div>
                                    </div>                                                                        
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="card-footer">
                        <div class="row">
                            <div class="col-sm-8">
                                <h5 style="font-size: 16px; color: #545b62; margin-top: 5px;"><strong>Campos com asterisco(*) devem ser informados</strong>.</h5>
                            </div>
                            <div class="col-sm-2">
                                <button id="btgravar" v-if="(opcrud == 1)" type="button" @click.prevent="mtdgravar()"
                                        v-bind:disabled="validou" class="btn btn-primary btn-sm"
                                        style="width:100%; margin-bottom:10px;"><i class="fa fa-check"></i> Gravar
                                </button>
                                <button id="btgravar" v-else-if="(opcrud == 2)" type="button" @click.prevent="mtdgravar()"
                                        v-bind:disabled="validou" class="btn btn-primary btn-sm"
                                        style="width:100%; margin-bottom:10px;"><i class="fa fa-check"></i> Alterar
                                </button>
                                <button id="btgravar" v-else-if="(opcrud == 3)" type="button" @click.prevent="mtdgravar()"
                                        v-bind:disabled="validou" class="btn btn-primary btn-sm"
                                        style="width:100%; margin-bottom:10px;"><i class="fa fa-check"></i> Excluir
                                </button>
                            </div>
                            <div class="col-sm-2">
                                <button type="button" @click.prevent="mtdcancelaredicao()" class="btn btn-secondary btn-sm" style="width:100%">
                                    <i class="fa fa-close"></i> Cancelar
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
                <div id="pnmonitoratividades" class="card" style="display:none;">
                    <div class="card-header"><span>{{itensbc.item2.titulo}}</span>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close" @click.prevent="mtdcancelaredicao()"><span aria-hidden="true">&times;</span></button>
                    </div>
                    <div class="card-body" style="padding-bottom: 0px;">
                        <div class="row" style="margin-bottom: 15px;">
							<div class="col-sm-12 col-md-5 col-lg-5">
								<span class="lblselect2">Filial:</span>
								<select id="cbfilialmonitora" data-placeholder="Selecione uma filial" v-model="midfilial" data-allow-clear="true" style="width:100%;">
								</select>
							</div>
							<div class="col-sm-12 col-md-2 col-lg-2">
								<label for="eddtini">De:</label>
								<div class="input-group">
									<date-picker id="eddtini" v-model="mdtini" :config="options" class="form-control form-control-sm"></date-picker>
									<div class="input-group-append">
										<span class="input-group-text"><i class="fa fa-calendar"></i></span>
									</div>								
								</div>
							</div>
							<div class="col-sm-12 col-md-2 col-lg-2">
								<label for="eddtfim">até:</label>
								<div class="input-group">
									<date-picker id="eddtfim" v-model="mdtfim" :config="options" class="form-control form-control-sm"></date-picker>
									<div class="input-group-append">
										<span class="input-group-text"><i class="fa fa-calendar"></i></span>
									</div>																			
								</div>
							</div>
							<div class="col-sm-12 col-md-3 col-lg-3">
								<span class="lblselect2">Usuário:</span>
								<select id="cbusuariomonitora" data-placeholder="Selecione um usuário" v-model="midusuario" data-allow-clear="true" style="width:100%;">
								</select>
							</div>                            
							<div class="col-sm-12 col-md-3 col-lg-3">
								<span class="lblselect2">Rotina:</span>
								<select id="cbrotinamonitora" data-placeholder="Selecione uma rotina" v-model="midrotina" data-allow-clear="true" style="width:100%;">
								</select>
							</div>                                                        
                            <div class="col-12 col-sm-12 col-md-2 col-lg-2">
                                <label for="cbordemmonitora">Ordem:</label>
                                <select name="cbordem" class="form-control form-control-sm" id="cbordemmonitora" v-model="mordem">
                                    <option value="0">Atividade</option>
                                    <option value="1">Filial</option>
                                    <option value="2">Usuário</option>
                                    <option value="3">Data/Hora</option>
                                </select>
                            </div>
                            <div class="col-12 col-sm-12 col-md-2 col-lg-2" style="padding-top: 20px;">
                                <button type="button" class="btn btn-primary btn-sm btn-block" @click.prevent="mtdlistaratividadesusuar()"><i class="fa fa-search"></i> Listar</button>                                
                            </div>
                            <div class="col-sm-12 col-md-10 col-lg-10">
                                <label for="edfiltromonitora">Filtrar:</label>
                                <input type="text" class="form-control form-control-sm" id="edfiltromonitora" v-model="mfiltro" data-bv-group=".group" maxlength="50">
                            </div>
                            <div class="col-12 col-sm-12 col-md-2 col-lg-2" style="padding-top: 20px;">
                                <button type="button" class="btn btn-info btn-sm btn-block" @click.prevent="mtddetalhesatividade()"><i class="fa fa-eye"></i> Analisar</button>                                
                            </div>                                                                                   							                                                        
                        </div>
                        <div class="row">
                            <div v-show="lstatividades.length > 0" class="container-fluid" style="margin-bottom: 15px; display: none;">
                                <ul class="list-group">
                                    <li v-for="(atividade, index) in lstatividades" class="list-group-item list-group-item-action" style="padding: 8px;" v-bind:key="index">
                                        <div class="row">
                                            <div class="col-md-2">
                                                <img class="mimgusuario" v-bind:src="pathfotovisualizar+atividade.foto" alt="Avatar">
                                                <span class="titlabels">{{atividade.nomeusu}}</span>
                                            </div>
                                            <div class="col-md-5" style="padding-top: 4px">
                                                <span class="titatividade" style="">{{atividade.descricao}}</span>
                                            </div>
                                            <div class="col-md-2" style="padding-top: 4px">
                                                <span class="titlabels">{{atividade.fantasia}}</span>
                                            </div>
                                            <div class="col-md-3" style="padding-top: 4px">
                                                <span class="titdata">{{mtdformadardataextenso(mtdtransformadata(atividade.dthratividade+'T00:00:00'), true)}}</span>
                                                <span v-if="atividade.detalhes.trim() !== ''" style="float: right;"><i class="fa fa fa-plus-circle btn-detalhes" @click.prevent="mtdadicionarjson(atividade)" data-toggle="tooltip" title="Adicionar para análise"></i></span>
                                            </div>
                                        </div>
                                    </li>
                                </ul>
                            </div>
                            <div v-show="lstatividades.length > 0" class="container-fluid border-top dvwhite" style="display: none; padding-top: 10px; padding-bottom: 10px;">
                                <div class="container">
                                    <div class="row">
                                        <div class="col-md-12">
                                            <ul class="list-group">
                                                <a class="list-group-item lstdetrec" style="color: #666;">Atividades encontradas: <span class="badge badge-info bdgtitulos">{{ lstatividades.length }}</span></a>
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                            </div>                            
                        </div>
                    </div>                                            
                    <div class="card-footer" style="padding: 10px;">
                        <div class="row">
                            <div class="col-8 col-sm-8 col-md-10 col-lg-10">            
                            </div>
                            <div class="col-4 col-sm-4 col-md-2 col-lg-2">
                                <button type="button" class="btn btn-secondary btn-sm btn-block" @click.prevent="mtdcancelaredicao()"><i class="fa fa-close"></i> Sair</button>
                            </div>
                        </div>
                    </div>                    
                </div>
            </div>
        </div>
        <!--Clonar perfil do usuário-->
        <div class="modal fade" id="mdObterPerilUsuario">
            <div class="modal-dialog modal-sm">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">Obter perfil</h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <div class="row">
                            <div class="col-md-12">
                                <span style="margin-bottom:0px;">*Usuário:</span>
                                <select id="cbusuarioperfilcopiar" v-model="vcodusucopiarperil" v-bind:disabled="ativadesativa"
                                        data-placeholder="Selecione uma opção" data-allow-clear="true" style="width:100%;">
                                </select>
                            </div>
                        </div>
                    </div>
                    <div class="modal-footer">
                        <a href="#" id="btconfirmarcopiaperfil" @click.prevent="mtdconfimarcopiaperfil()" class="btn btn-primary btn-sm" role="button" style="min-width: 100px;"><i class="fa fa-check-circle"></i> Confirmar</a>
                        <a href="#" class="btn btn-secondary btn-sm" role="button" data-dismiss="modal" style="min-width: 100px;"><i class="fa fa-close"></i> Cancelar</a>
                    </div>
                </div>
            </div>
        </div>

        <!-- modal para analisar a atividade -->
        <div class="modal fade" id="mdldetalhes">
            <div class="modal-dialog modal-dialog-centered modal-xl">
                <div class="modal-content">
                    <div class="modal-header">
                        <h4 class="modal-title">Analisador de atividades</h4>
                        <button type="button" class="close" data-dismiss="modal">&times;</button>
                    </div>
                    <div class="modal-body">
                        <div class="container-fluid">
                            <div class="row">
                                <div v-for="(conteudojson, indice) in lstdetalhes" class="col-md-4" v-bind:key="indice">
                                    <div class="container-fluid">
                                        <div class="row">
                                            <div class="col-md-12 border rounded" style="padding-top: 5px; margin-bottom: 5px;">
                                                <h6 style="font-family: DosisBold; color: #666666; margin-left: 20px;">{{conteudojson.descricao}}</h6>
                                                <span style="float: right; top: 5px; position: absolute; float: right;"><i class="fa fa-trash btn-detalhes" @click.prevent="mtddelitemanalisar(indice)" data-toggle="tooltip" title="Excluir"></i></span>
                                            </div>
                                            <div class="col-md-12 border rounded" v-bind:id="'detjson'+indice">

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-secondary btn-sm" data-dismiss="modal"><i class="fa fa-close"></i> Fechar</button>
                    </div>
                </div>
            </div>
        </div>        
    </div>
</template>
<script>
    import BreadCrumb from '../components/cmpbreadcrumb.vue'
    import VueBootstrap4Table from 'vue-bootstrap4-table'
    import vPagination from 'vue-plain-pagination'
    import util from '../utilitarios/util.js'
    import jsvw from '../utilitarios/jsonview.js'

    export default {
        name: 'cadusuarios',
        components:{
            VueBootstrap4Table,
            vPagination,
            'breadcrumb' : BreadCrumb
        },
        data: function() {
            return {                
                utodasfiliais 		: this.$store.state.usuario.todasfiliais,
                lstusuarios  : [],
                pfiltro      : 1,
                pconteudo    : '',
                pativo       : 2,
                pqtdregistros: 10,
                pqtd_paginas : 1,
                pagina_atual : 1,
                pqtd_total_registros: 0,

                //variáveis do crud
                lstMenuUsuario      : [],
                lstFiliais          : [],
                lsttabelasve        : [],
                opcrud              : 0,
                vcodusu             : '',
                vnomeusu            : '',
                vloginusu           : '',
                vsenhausu           : '',
                vcodfil             : null,
                vidvendedor         : null,
                vidgrupo            : null,
                vemailusu           : '',
                vativo              : 1,
                vestoquegeralconsultas : 0,
                vativoold           : 1,
                vdefinirsenhalogin  : 1,
                vdescontoprodutos      : 0,
                vdescontoprodutosprazo : 0,
                vdescontoservicos   : 0,
                vdescontojuros      : 0,
                vdescontomulta      : 0, 
                vlimitecreditoautorizar: 0,               
                vtodasfiliais       : 0,
                vfoto               : '',
                vdiretorioimagem    : '',
                vclientesvendedor   : false,
                vsalesagent         : false,

                vcardresumopedidos   : false,
                vcardfinanceiro      : false,
                vcardrecursos    : false,
                vcardvendedores      : false,
                vcardcompra          : false,


                //variável para habilitação dos campos
                ativadesativa       : true,

                //variável p/ clonar perfil
                vcodusucopiarperil  : null,

                //rotina imagens
                arqimgselecionado   : null,

                //pega o path do diretorio padrão das imagens
                pathimgview         : this.$store.state.configpaths.pathimagens,


                //path com o caminho pronto da logo da filial para visualização
                pathimagemvisualizar: '',

                //variáveis do monitoramento
                pathfotovisualizar  : this.$store.state.configpaths.pathimagens,
                mfiltro             : '',
                midfilial           : null,
				mdtini       		: util.DataAtual(true),
				mdtfim       		: util.DataAtual(true),
                mordem              : 3,				
                midusuario          : null,
                midrotina           : null,
                lstetividadesencontradas : [],
                lstatividades            : [],
                lstdetalhes              : [],

                options: {
                    format           : 'DD/MM/YYYY',
                    useCurrent       : false,
                    locale           : 'pt-BR'
                },
                money: {
                    decimal         : ',',
                    thousands       : '.',
                    prefix          : '',//aqui colocar o cifrão se for necessário
                    precision       : 2,
                    masked          : false
                },
                bootstrapPaginationClasses: {
                    ul: 'pagination pagination-sm',
                    li: 'page-item',
                    liActive: 'active',
                    liDisable: 'disabled',
                    button: 'page-link'
                },
                itensbc : {
                    item1 : {
                        titulo : 'USUÁRIOS',
                        ativo  : false
                    },
                    item2 : {
                        titulo : '',
                        ativo  : false
                    }
                },
                columns: [
                    {
                        label: 'Opções',
                        name : 'opcoes',
                        row_text_alignment: "text-center",
                        column_text_alignment: "text-center",
                        row_classes: "def-col-opcoes",
                        sort: false
                    },
                    {
                        label: "Código",
                        name: "codusu",
                        sort: true,
                        slot_name: "codusu_f",
                        row_classes: "def-col-cod",
                    },
                    {
                        label: "Situação",
                        name: "ativo",
                        sort: true,
                        slot_name: "slot_situacao",
                        row_classes: "def-col-cod",
                    },{
                        label: "Nome",
                        name: "nomeusu",
                        initial_sort : true,//acrescentar isso na coluna que for iniciar ordenado
                        initial_sort_order: 'asc',
                        sort: true,
                        row_text_alignment: "text-left",
                        column_text_alignment: "text-left"
                    },
                    {
                        label: "Login",
                        name: "loginusu",
                        initial_sort_order: 'asc',
                        sort: true,
                        row_text_alignment: "text-left",
                        column_text_alignment: "text-left"
                    },
                    {
                        label: "E-mail",
                        name: "emailusu",
                        initial_sort_order: 'asc',
                        sort: true,
                        row_text_alignment: "text-left",
                        column_text_alignment: "text-left"
                    }
                ],
                config: {
                    pagination: false,
                    pagination_info: false,
                    card_mode: false,
                    global_search: {
                        visibility: false,
                    },
                    show_refresh_button : false,
                    show_reset_button : false
                },
                classes: {
                    table: "table-bordered table-striped table-sm"
                }
            }
        },
        methods:{
            mtdformadardataextenso(data, mostrahr) {
                if (!mostrahr) {
                    return util.dataextenso(util.InverterData(data) + 'T00:00:00');
                }else{
                    let vdthr = data.split('T');
                    let vhr   = vdthr[1].split(':');
                    return util.dataextenso(util.InverterData(data) + 'T00:00:00')+' às '+vhr[0]+':'+vhr[1];
                }
            },
            mtdtransformadata: function(dttrasnf){
                return util.formatadatahrdb(dttrasnf);
            }, 
            mtdselecionarimagemusuario(event){                
                let vself = this;                 
                vself.arqimgselecionado = event.target.files[0];
                let loader      = vself.$loading.show();
                let localsalvar = vself.$store.state.configpaths.pathimgusuarios + vself.$store.state.filialpadrao.idcliente+'/'+vself.vdiretorioimagem;

                let parametros      = [
                    {parametro: 'arquivo',          valor  : vself.arqimgselecionado},
                    {parametro: 'localsalvar',      valor  : localsalvar},
                    {parametro: 'nomearquivo',      valor  : vself.arqimgselecionado.name}
                ];
                let retorno     = util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv+'/controller/uploadfile.php');
                retorno.then(function (response) {
                    if ($.isNumeric(response.data.inf)){
                        vself.vfoto                = localsalvar+'/'+vself.arqimgselecionado.name;                        
                        vself.arqimgselecionado    = null;
                        vself.pathimagemvisualizar = vself.pathimgview+vself.vfoto;
                        vself.$toastr.s('Imagem enviada com sucesso!', 'Informação!');
                        $('#ipselecionarimgusuario').val('');
                    }else{
                        vself.vfoto             = '';                        
                        vself.arqimgselecionado = null;
                        $('#ipselecionarimgusuario').val('');
                        vself.$toastr.e('Descrição do erro: '+response.data, 'Erro!');
                    }
                    loader.hide();
                }).catch(function (response) {
                    loader.hide();
                    vself.$toastr.e('Descrição do erro: '+response.message, 'Erro!');
                    vself.vfoto             = '';                        
                    vself.arqimgselecionado = null;
                    $('#ipselecionarimgfilial').val('');
                });                
            },
            mtdexcluirimgusuario(){
                let vself = this;
                if (!util.contemstring(vself.pathimagemvisualizar, 'semimagem')){                    
                    let loader       = vself.$loading.show();
                    let localarquivo = vself.$store.state.configpaths.pathimgusuarios + 
                                    vself.$store.state.filialpadrao.idcliente +'/'+
                                    vself.vdiretorioimagem;

                    let parametros      = [
                        {parametro: 'op',               valor  : "excluirarquivo"},
                        {parametro: 'patharquivo',      valor  : vself.vfoto},
                        {parametro: 'localarquivo',     valor  : localarquivo}
                        
                    ];
                    let retorno     = util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv+'/controller/auxiliares.php');
                    retorno.then(function (response) {
                        if ($.isNumeric(response.data.inf)){
                            vself.$toastr.s('Imagem excluída com sucesso!', 'Informação!');
                            vself.vfoto = '';
                            vself.pathimagemvisualizar = vself.$store.state.configpaths.pathimagens+'imagens/semimagem.png';
                        }else{                        
                            vself.$toastr.e('Descrição do erro: '+response.data, 'Erro!');
                        }
                        loader.hide();
                    }).catch(function (response) {
                        loader.hide();
                        vself.$toastr.e('Descrição do erro: '+response.message, 'Erro!');
                    });                  
                }
            },            
            mtdmenubase(){
                let vself = this;
                let parametros  = [
                    {parametro: 'idclientesac', valor  : vself.$store.state.filialpadrao.idcliente},
                    {parametro: 'op',           valor  : 'menubase'}
                ];
                let retorno     = util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv+'/controller/rtcadusuarios.php');
                return retorno;
            },
            mtdselect2_def(){
                let vself = this;
				
                let sqliniusuario = parseInt(vself.utodasfiliais) === 0 ? 'select f.codfil, f.fantasia from tbfiliaisusuario fu left join tbfiliais f on f.codfil=fu.idfilial ' : 'select codfil, fantasia from tbfiliais ';
				let sqlfimusuario = parseInt(vself.utodasfiliais) === 0 ? 'where upper(f.fantasia) like upper("%@@%") and fu.idusuario='+vself.$store.state.usuario.id 		 : 'where upper(fantasia) like upper("%@@%")';                

                $("#cbfilial").select2({
                        id: function (e) {return e.id},
                        ajax: {
                            url: vself.$store.state.configpaths.pathselect2,
                            dataType: 'json',
                            delay: 250,
                            data: function (params) {
                                return {
                                    q: params.term,
                                    idclientesac : vself.$store.state.filialpadrao.idcliente,
                                    tb: 'tbfiliais',
                                    c1: 'codfil',
                                    c2: 'descfil'
                                };
                            },
                            processResults: function (data) {
                                return {
                                    results: data
                                };
                            },
                            cache: true
                        },
                        minimumInputLength: 0,
                        theme: 'bootstrap',
                        language: "pt-BR",
                        templateResult: util.formatResult,
                        templateSelection: util.formatSelection
                    }
                ).change(function () {
                    vself.vcodfil = $("#cbfilial").val();
                });
                $("#cbvendedor").select2({
                        id: function (e) {return e.id},
                        ajax: {
                            url: vself.$store.state.configpaths.pathselect2,
                            dataType: 'json',
                            delay: 250,
                            data: function (params) {
                                return {
                                    q: params.term,
                                    idclientesac : vself.$store.state.filialpadrao.idcliente,
                                    tb: 'tbvendedores',
                                    c1: 'id',
                                    c2: 'nome'
                                };
                            },
                            processResults: function (data) {
                                return {
                                    results: data
                                };
                            },
                            cache: true
                        },
                        minimumInputLength: 0,
                        theme: 'bootstrap',
                        language: "pt-BR",
                        templateResult: util.formatResult,
                        templateSelection: util.formatSelection
                    }
                ).change(function () {
                    vself.vidvendedor = $("#cbvendedor").val();
                });                
                $("#cbgrupo").select2({
                        id: function (e) {return e.id},
                        ajax: {
                            url: vself.$store.state.configpaths.pathselect2,
                            dataType: 'json',
                            delay: 250,
                            data: function (params) {
                                return {
                                    q: params.term,
                                    idclientesac : vself.$store.state.filialpadrao.idcliente,
                                    tb: 'tbgruposusuarios',
                                    c1: 'id',
                                    c2: 'descricao'
                                };
                            },
                            processResults: function (data) {
                                return {
                                    results: data
                                };
                            },
                            cache: true
                        },
                        minimumInputLength: 0,
                        theme: 'bootstrap',
                        language: "pt-BR",
                        templateResult: util.formatResult,
                        templateSelection: util.formatSelection
                    }
                ).change(function () {
                    vself.vidgrupo = $("#cbgrupo").val();
                });
                $("#cbusuarioperfilcopiar").select2({
                        id: function (e) {return e.codusu},
                        ajax: {
                            url: vself.$store.state.configpaths.pathselect2,
                            dataType: 'json',
                            delay: 250,
                            data: function (params) {
                                return {
                                    q: params.term,
                                    idclientesac : vself.$store.state.filialpadrao.idcliente,
                                    tb: 'tbusuarios',
                                    c1: 'codusu',
                                    c2: 'nomeusu'
                                };
                            },
                            processResults: function (data) {
                                return {
                                    results: data
                                };
                            },
                            cache: true
                        },
                        minimumInputLength: 0,
                        theme: 'bootstrap',
                        language: "pt-BR",
                        templateResult: util.formatResult,
                        templateSelection: util.formatSelection
                    }
                ).change(function () {
                    vself.vcodusucopiarperil = $("#cbusuarioperfilcopiar").val();
                });
            
				//selects da consulta
				$("#cbfilialmonitora").select2({
					id: function (e) {return e.codfil},
					ajax: {						
						url: vself.$store.state.configpaths.pathselect2sql,						
						dataType: 'json',
						delay: 250,
						data: function (params) {
							return {
								q		: params.term,
								idclientesac : vself.$store.state.filialpadrao.idcliente,
								sqlini	: sqliniusuario,
								sqlfim	: sqlfimusuario,
								cpid	: 'codfil',
								cpdesc	: 'fantasia'
							};
						},
						processResults: function (data) {
							return {
								results: data
							};
						},
						cache: true
					},
					minimumInputLength: 0,
					theme: 'bootstrap',
					language: "pt-BR",
					templateResult: util.formatResult,
					templateSelection: util.formatSelection
				}).change(function () {
					vself.midfilial = $("#cbfilialmonitora").val();
				});            
				$("#cbusuariomonitora").select2({
					id: function (e) {return e.id},
					ajax: {
						url: vself.$store.state.configpaths.pathselect2,
						dataType: 'json',
						delay: 250,
						data: function (params) {
							return {
								q: params.term,
								idclientesac : vself.$store.state.filialpadrao.idcliente,
								tb: 'tbusuarios',
								c1: 'codusu',
								c2: 'nomeusu'
							};
						},
						processResults: function (data) {
							return {
								results: data
							};
						},
						cache: true
					},
					minimumInputLength: 0,
					theme: 'bootstrap',
					language: "pt-BR",
					templateResult: util.formatResult,
					templateSelection: util.formatSelection
				}).change(function () {
					vself.midusuario = $("#cbusuariomonitora").val();
				});            
				$("#cbrotinamonitora").select2({
					id: function (e) {return e.codfil},
					ajax: {						
						url: vself.$store.state.configpaths.pathselect2sql,						
						dataType: 'json',
						delay: 250,
						data: function (params) {
							return {
								q		: params.term,
								idclientesac : vself.$store.state.filialpadrao.idcliente,
								sqlini	: 'select * from tbmenu ',
								sqlfim	: 'where classe="menuprincipal" and upper(descricao) like upper("%@@%")',
								cpid	: 'codop',
								cpdesc	: 'descricao'
							};
						},
						processResults: function (data) {
							return {
								results: data
							};
						},
						cache: true
					},
					minimumInputLength: 0,
					theme: 'bootstrap',
					language: "pt-BR",
					templateResult: util.formatResult,
					templateSelection: util.formatSelection
				}).change(function () {
					vself.midrotina = $("#cbrotinamonitora").val();
				});
            },
            mtdfiltropesquisa(){
                let rfiltro = '';
                if (parseInt(this.pfiltro) === 0){
                    rfiltro = this.pconteudo === '' ? '' : ' and u.codusu='+this.pconteudo;
                }else{
                    rfiltro = this.pconteudo === '' ? '' : ' and upper(u.nomeusu) like upper("'+this.pconteudo+'%")';
                }
                if (parseInt(this.pativo) < 2){
                    rfiltro = rfiltro + ' and u.ativo='+this.pativo;
                }
                return rfiltro;
            },
            mtdexecutapesquisa(){
                var vself           = this;
                let filtro          = vself.mtdfiltropesquisa();
                this.pagina_atual   = 1;
                let parametros      = [
                    {parametro: 'idclientesac', valor  : vself.$store.state.filialpadrao.idcliente},
                    {parametro: 'op',           valor  : 'qtdregistros'},
                    {parametro: 'filtro',       valor  : filtro}
                ];
                let retorno     = util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv+'/controller/rtcadusuarios.php');
                retorno.then(function (response) {
                    vself.pqtd_total_registros = parseInt(response.data.qtdregistros);
                    let qtdpg                  = Math.ceil(vself.pqtd_total_registros / vself.pqtdregistros);
                    vself.pqtd_paginas         = qtdpg > 0 ? qtdpg : 1;
                    vself.mtdcarregausuarios(1);
                }).catch(function (response) {
                    alert('Erro ao consultar registros');
                });
            },
            mtdcarregausuarios(ipagina){
                var vself       = this;
                let loader      = this.$loading.show();
                let filtro      = vself.mtdfiltropesquisa();
                let parametros  = [
                    {parametro: 'idclientesac', valor  : vself.$store.state.filialpadrao.idcliente},
                    {parametro: 'op',           valor : 'listagem'},
                    {parametro: 'filtro',       valor : filtro},
                    {parametro: 'limit',        valor : vself.pqtdregistros},
                    {parametro: 'offset',       valor : (parseInt(ipagina) -1) * parseInt(vself.pqtdregistros)},
                ];
                let retorno           = util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv+'/controller/rtcadusuarios.php');
                retorno.then(function (response) {
                    vself.lstusuarios = response.data;
                    loader.hide();
                }).catch(function (response) {
                    vself.lstusuarios = [];
                    loader.hide();
                });
            },
            resetarDados() {
                util.toTop();

                this.vcodusu              = '';
                this.vnomeusu             = '';
                this.vloginusu            = '';
                this.vsenhausu            = '';
                this.vcodfil              = null;
                this.vidvendedor          = null;
                this.vidgrupo             = null;
                this.vemailusu            = '';
                this.vativo               = 1;
                this.vestoquegeralconsultas= 0,
                this.vativoold            = 1;
                this.vdefinirsenhalogin   = 1;
                this.vtodasfiliais        = 0;
                this.vfoto                = '';
                this.vdiretorioimagem     = '';
                this.vdescontoprodutos    = 0;
                this.vdescontoprodutosprazo = 0;
                this.vdescontoservicos    = 0;               
                this.vdescontojuros       = 0;
                this.vdescontomulta       = 0;
                this.vlimitecreditoautorizar = 0;

                this.vclientesvendedor     = false;
                this.vsalesagent           = false;  

                this.vcardresumopedidos    = false;
                this.vcardfinanceiro       = false;
                this.vcardrecursos     = false;
                this.vcardvendedores       = false;
                this.vcardcompra           = false;

                $('#cbfilial').val(null).trigger('change');
                $('#cbvendedor').val(null).trigger('change');
                $('#cbgrupo').val(null).trigger('change');
            },
            mtddefault(){
                $('#pnlista').hide();
                this.resetarDados();
                $('#pncadastro').fadeIn(700);
                this.$nextTick(function () {
                    if (parseInt(this.opcrud) < 3) {
                        $('#ednome').focus();
                    } else {
                        $('#btgravar').focus();
                    }
                });
            },
            mtdpreparacrud(op) {
                let vself  = this;
                vself.opcrud = op;
                $('.nav-tabs a[href="#dvperfil"]').tab('show');
                if (parseInt(op) === 1) {
                    let loader = vself.$loading.show();
                    let respmenu = vself.mtdmenubase();
                    respmenu.then(function (response) {
                        loader.hide();
                        vself.lstMenuUsuario = response.data.menu;
                        vself.lstFiliais     = response.data.filiais;
                        vself.lsttabelasve   = response.data.tabelas;
                        vself.mtddefault();
                    }).catch(function (response) {
                        loader.hide();
                        console.log(response);
                        alert('Erro ao consultar registros');
                    });
                }else{
                    vself.mtddefault();
                }
            },
            mtdnovo(){
                if (!util.opcaousuario('002Z.001L.001L', this.$store.state.perfilusuario)){
                    this.$toastr.i('Acesso não permitido para o usuário!', 'Informação!');
                }else {
                    this.itensbc.item2.titulo = 'INCLUSÃO DE USUÁRIOS';
                    this.itensbc.item1.ativo = true;
                    this.itensbc.item2.ativo = true;
                    this.ativadesativa = false;
                    this.mtdpreparacrud(1);
                    this.vdiretorioimagem     = util.GerarStringAleatoria();
                    this.pathimagemvisualizar = this.$store.state.configpaths.pathimagens+'imagens/semimagem.png';                        
                }
            },
            mtdcancelaredicao(){
                this.itensbc.item1.ativo = false;
                this.itensbc.item2.ativo = false;                
                $('#pnmonitoratividades').hide();
                $('#pncadastro').hide();
                $('#pnlista').fadeIn(700);
                $('#edconteudopesq').focus();
                setTimeout(function(){
                    util.toTop();
                }, 200);
            },
            mtdlimpar_listagem(){
                this.lstusuarios    = [];
                this.pagina_atual   = 1;
                this.filtro         = '';
                this.pqtd_total_registros   = 0;
                this.pqtd_paginas           = 0;
            },
            mtdaplicaselecao: function(valoratribuir){
                for (var i = 0; i < this.lstMenuUsuario.length; i++) {
                    this.lstMenuUsuario[i].habilita = valoratribuir;
                }
            },
            mtdmarcartodosopcoesusuario(){
                if (util.findValInArray(this.lstMenuUsuario, 'habilita', 0)){
                    this.mtdaplicaselecao(1);
                }else{
                    this.mtdaplicaselecao(0);
                }
            },
            mtdhabilitaop(index){
                if (this.opcrud < 3) {
                    if (parseInt(this.lstMenuUsuario[index].habilita) === 0) {
                        this.lstMenuUsuario[index].habilita = 1;
                    } else {
                        this.lstMenuUsuario[index].habilita = 0;
                    }
                    if (this.lstMenuUsuario[index].classe === 'menuprincipal') {
                        var codop = this.lstMenuUsuario[index].codop;
                        i = index + 1;
                        while (this.lstMenuUsuario[i].codop.substring(0, 4) === codop) {
                            this.lstMenuUsuario[i].habilita = this.lstMenuUsuario[index].habilita;
                            if (i < this.lstMenuUsuario.length - 1) {
                                i++;
                            } else {
                                break;
                            }
                        }
                    } else if (this.lstMenuUsuario[index].classe === 'menusecundario') {
                        var cop = this.lstMenuUsuario[index].codop.substring(0, 4);//código da opção principal
                        var indcop = util.getArrayIndexForKey(this.lstMenuUsuario, 'codop', cop);

                        var codop = this.lstMenuUsuario[index].codop;
                        let i = index + 1;
                        while (this.lstMenuUsuario[i].codop.substring(0, 9) === codop) {
                            this.lstMenuUsuario[i].habilita = this.lstMenuUsuario[index].habilita;
                            if (i < this.lstMenuUsuario.length - 1) {
                                i++;
                            } else {
                                break;
                            }
                        }

                        //verifica se existem ítens com a opção principal marcada
                        var achou = false;
                        var w = indcop + 1;
                        while (this.lstMenuUsuario[w].codop.substring(0, 4) === cop) {
                            if (parseInt(this.lstMenuUsuario[w].habilita) === 1) {
                                achou = true;
                                break;
                            }
                            if (w < this.lstMenuUsuario.length - 1) {
                                w++;
                            } else {
                                break;
                            }
                        }
                        if (!achou) {
                            this.lstMenuUsuario[indcop].habilita = 0;
                        } else {
                            this.lstMenuUsuario[indcop].habilita = 1;
                        }
                    } else if (this.lstMenuUsuario[index].classe === 'itensmenusec') {
                        var codop    = this.lstMenuUsuario[index].codop.substring(0, 4);
                        var codopms  = this.lstMenuUsuario[index].codop.substring(0, 9);
                        var indprinc = util.getArrayIndexForKey(this.lstMenuUsuario, 'codop', codopms);
                        var indop    = util.getArrayIndexForKey(this.lstMenuUsuario, 'codop', codop);
                        if (parseInt(this.lstMenuUsuario[index].habilita) === 1) {
                            this.lstMenuUsuario[indprinc].habilita = 1;
                            this.lstMenuUsuario[indop].habilita    = 1;
                        } else {
                            var p = indprinc + 1;
                            var achou = false;
                            while (this.lstMenuUsuario[p].codop.substring(0, 9) === codopms) {
                                if (parseInt(this.lstMenuUsuario[p].habilita) === 1) {
                                    achou = true;
                                    break;
                                }
                                if (p < this.lstMenuUsuario.length - 1) {
                                    p++;
                                } else {
                                    break;
                                }
                            }
                            if (!achou) {
                                this.lstMenuUsuario[indprinc].habilita = 0;
                            }
                            //verifica se existem ítens com a opção principal marcada
                            var w = indop + 1;
                            while (this.lstMenuUsuario[w].codop.substring(0, 4) === codop) {
                                if (parseInt(this.lstMenuUsuario[w].habilita) === 1) {
                                    achou = true;
                                    break;
                                }
                                if (w < this.lstMenuUsuario.length - 1) {
                                    w++;
                                } else {
                                    break;
                                }
                            }
                            if (!achou) {
                                this.lstMenuUsuario[indop].habilita = 0;
                            }
                        }
                    }
                }
            },
            mtdaplicaselecaofilial: function(valoratribuir){
                for (var i = 0; i < this.lstFiliais.length; i++) {
                    this.lstFiliais[i].habilita = valoratribuir;
                }
            },
            mtdmarcartodasfiliais(){
                if (util.findValInArray(this.lstFiliais, 'habilita', 0)){
                    this.mtdaplicaselecaofilial(1);
                }else{
                    this.mtdaplicaselecaofilial(0);
                }
            },
            mtdhabilitafilial(index){
                if (this.opcrud < 3) {
                    if (parseInt(this.lstFiliais[index].habilita) === 0) {
                        this.lstFiliais[index].habilita = 1;
                    } else {
                        this.lstFiliais[index].habilita = 0;
                    }
                }
            },
            mtdaplicaselecaotabela: function(valoratribuir){
                for (var i = 0; i < this.lsttabelasve.length; i++) {
                    this.lsttabelasve[i].habilita = valoratribuir;
                }
            },
            mtdmarcartodastabelas(){
                if (util.findValInArray(this.lsttabelasve, 'habilita', 0)){
                    this.mtdaplicaselecaotabela(1);
                }else{
                    this.mtdaplicaselecaotabela(0);
                }
            },
            mtdhabilitatabela(index){
                if (this.opcrud < 3) {
                    if (parseInt(this.lsttabelasve[index].habilita) === 0) {
                        this.lsttabelasve[index].habilita = 1;
                    } else {
                        this.lsttabelasve[index].habilita = 0;
                    }
                }
            },            
            mtdchamarcopiarperfil() {
                if (!util.opcaousuario('002Z.001L.005L', this.$store.state.perfilusuario)){
                    this.$toastr.i('Acesso não permitido para o usuário!', 'Informação!');
                }else {
                    this.vcodusucopiarperil = null;
                    $("#mdObterPerilUsuario").modal('show');
                    $('#cbusuarioperfilcopiar').val(null).trigger('change');
                }
            },
            mtdconfimarcopiaperfil() {
                if (this.vcodusucopiarperil === null){
                    this.$toastr.w("Usuário para a cópia do perfil deve ser informado!", "Atenção!");
                    $('#cbusuarioperfilcopiar').focus();
                    return;
                }
                if (this.vcodusu !== ""){
                    if (parseInt(this.vcodusucopiarperil) === parseInt(this.vcodusu)){
                        this.$toastr.w("Perfil não pode ser atribuído para o mesmo usuário!", "Atenção!");
                        $('#cbusuarioperfilcopiar').focus();
                        return;
                    }
                }
                this.lstMenuUsuario = [];
                let vself           = this;
                let loader          = vself.$loading.show();
                let filtro          = " and codusu="+vself.vcodusucopiarperil;
                let parametros  = [
                    {parametro: 'idclientesac', valor  : vself.$store.state.filialpadrao.idcliente},
                    {parametro: 'op',           valor : 'listagem'},
                    {parametro: 'filtro',       valor : filtro},
                    {parametro: 'limit',        valor : 1},
                    {parametro: 'offset',       valor : 0},
                ];
                let retorno     = util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv+'/controller/rtcadusuarios.php');
                retorno.then(function (response) {
                    loader.hide();
                    vself.lstMenuUsuario  = [];
                    vself.lstMenuUsuario  = response.data[0].menu;
                    $("#mdObterPerilUsuario").modal('hide');
                }).catch(function (response) {
                    loader.hide();
                });
            },
            mtdgravar(){
                let vself = this;
                if (parseInt(vself.opcrud) < 3) {
                    if (parseInt(vself.vtodasfiliais) === 0) {
                        if (vself.lstFiliais.length === 0) {
                            vself.$toastr.w('Informe ao menos uma filial para o usuário ter acesso!', 'Atenção!');
                            $('.nav-tabs a[href="#dvfiliais"]').tab('show');
                            return;
                        }
                        if (!util.findValInArray(vself.lstFiliais, 'codfil', vself.vcodfil)) {
                            vself.$toastr.w('Filial definida como padrão, não está na lista de permissões do usuário!', 'Atenção!');
                            $('.nav-tabs a[href="#dvfiliais"]').tab('show');
                            return;
                        }
                        if (parseInt(util.getValInArray(vself.lstFiliais, 'codfil', vself.vcodfil, 'habilita')) === 0) {
                            vself.$toastr.w('Filial definida como padrão, não está selecionada na lista de permissões do usuário!', 'Atenção!');
                            $('.nav-tabs a[href="#dvfiliais"]').tab('show');
                            return;
                        }
                    }
                }
                $.confirm({
                    title: 'Confirmação!',
                    content: 'Confirma ' + vself.itensbc.item2.titulo + '?',
                    icon: 'fa fa-question-circle',
                    escapeKey: true,
                    backgroundDismiss: false,
                    escapeKey: 'nao',
                    type: 'dark',
                    typeAnimated: true,
                    buttons: {
                        sim: {
                            text: '<u>S</u>im',
                            keys: ['s', 'S'],
                            btnClass: 'btn-blue',
                            action: function () {
                                $('.btn-blue').prop('disabled', true);
                                vself.mtdregistro();
                            },
                        },
                        nao: {
                            text: '<u>N</u>ão',
                            keys: ['n', 'N'],
                            action: function () {
                                $('#btgravar').focus();
                            }
                        }
                    }
                });
            },
            mtdlocalizaregistro(id){
                var vself       = this;
                let loader      = vself.$loading.show();
                let filtro      = ' and u.codusu='+id;
                let parametros  = [
                    {parametro: 'op',           valor : 'listagem'},
                    {parametro: 'idclientesac', valor  : vself.$store.state.filialpadrao.idcliente},
                    {parametro: 'filtro',       valor : filtro},
                    {parametro: 'limit',        valor : 1},
                    {parametro: 'offset',       valor : 0},
                ];
                let retorno           = util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv+'/controller/rtcadusuarios.php');
                retorno.then(function (response) {
                    loader.hide();
                    vself.mtdigualarcampos(response.data[0]);
                    if (parseInt(vself.opcrud) < 3){
                        $('#ednome').focus();
                    }else{
                        $('#btgravar').focus();
                    }
                }).catch(function (response) {
                    loader.hide();
                });
            },
            mtdalterar(item){
                if (!util.opcaousuario('002Z.001L.002L', this.$store.state.perfilusuario)){
                    this.$toastr.i('Acesso não permitido para o usuário!', 'Informação!');
                }else {
                    this.itensbc.item2.titulo = 'ALTERAÇÃO DO USUÁRIO';
                    this.itensbc.item1.ativo = true;
                    this.itensbc.item2.ativo = true;
                    this.ativadesativa = false;
                    this.mtdpreparacrud(2);
                    this.mtdlocalizaregistro(item.codusu);
                }
            },
            mtdexcluir(item){
                if (!util.opcaousuario('002Z.001L.003L', this.$store.state.perfilusuario)){
                    this.$toastr.i('Acesso não permitido para o usuário!', 'Informação!');
                }else {
                    this.itensbc.item2.titulo = 'EXCLUSÃO DO USUÁRIO';
                    this.itensbc.item1.ativo = true;
                    this.itensbc.item2.ativo = true;
                    this.ativadesativa = true;
                    this.mtdpreparacrud(3);
                    this.mtdlocalizaregistro(item.codusu);
                }
            },
            mtdigualarcampos(registro){
                this.vcodusu             = registro.codusu;
                this.vnomeusu            = registro.nomeusu;
                this.vloginusu           = registro.loginusu;
                this.vsenhausu           = registro.senhausu;
                this.vcodfil             = registro.codfil;
                this.vidvendedor         = registro.idvendedor;
                this.vidgrupo            = registro.idgrupo;
                this.vemailusu           = registro.emailusu;
                this.vativo              = registro.ativo;
                this.vestoquegeralconsultas = registro.estoquegeralconsultas;
                this.vativoold           = registro.ativo;
                this.vdefinirsenhalogin  = registro.definirsenhalogin;
                this.vdescontoprodutos   = registro.descontoprodutos;
                this.vdescontoprodutosprazo = registro.descontoprodutosprazo;
                this.vdescontoservicos   = registro.descontoservicos;
                this.vdescontojuros      = registro.descontojuros;
                this.vdescontomulta      = registro.descontomulta;                
                this.vlimitecreditoautorizar = registro.limitecreditoautorizar;
                this.vtodasfiliais       = registro.todasfiliais;
                this.vdiretorioimagem    = registro.diretorioimagem === '' ? util.GerarStringAleatoria() : registro.diretorioimagem;
                this.vfoto               = registro.foto;
                this.vclientesvendedor   = parseInt(registro.clientesvendedor) === 0 ? false : true;
                this.vsalesagent         = parseInt(registro.salesagent) === 0 ? false : true;

                this.vcardresumopedidos   = parseInt(registro.cardresumopedidos) === 0 ? false : true;
                this.vcardfinanceiro      = parseInt(registro.cardfinanceiro) === 0 ? false : true;
                this.vcardrecursos    = parseInt(registro.cardrecursos) === 0 ? false : true;
                this.vcardvendedores      = parseInt(registro.cardvendedores) === 0 ? false : true;     
                this.vcardcompra          = parseInt(registro.cardcompra) === 0 ? false : true;              

                this.pathimagemvisualizar= this.pathimgview+this.vfoto;
                
                this.lstMenuUsuario      = registro.menu;
                this.lstFiliais          = registro.filiais;
                this.lsttabelasve        = registro.tabelas;

                var defvendedor = new Option(registro.nomevendedor, this.vidvendedor, true, true);
                $('#cbvendedor').append(defvendedor).trigger('change');

                var deffilial = new Option(registro.fantasia, this.vcodfil, true, true);
                $('#cbfilial').append(deffilial).trigger('change');

                var defgrupo = new Option(registro.descgrupo, this.vidgrupo, true, true);
                $('#cbgrupo').append(defgrupo).trigger('change');
            },
            mtdregistro(){
                let vself  = this;
                let loader = vself.$loading.show();
                let registrocrud = {
                    'codusu'                : this.vcodusu,
                    'nomeusu'               : this.vnomeusu,
                    'loginusu'              : this.vloginusu,
                    'senhausu'              : this.vsenhausu,
                    'emailusu'              : this.vemailusu,
                    'codfil'                : this.vcodfil,
                    'idvendedor'            : this.vidvendedor,
                    'idgrupo'               : this.vidgrupo,
                    'ativo'                 : this.vativo,
                    'estoquegeralconsultas' : this.vestoquegeralconsultas,
                    'ativoold'              : this.vativoold,
                    'definirsenhalogin'     : this.vdefinirsenhalogin,
                    'descontoprodutos'      : this.vdescontoprodutos,
                    'descontoprodutosprazo' : this.vdescontoprodutosprazo,
                    'descontoservicos'      : this.vdescontoservicos,
                    'descontojuros'         : this.vdescontojuros,
                    'descontomulta'         : this.vdescontomulta,
                    'limitecreditoautorizar': this.vlimitecreditoautorizar,
                    'clientesvendedor'      : this.vclientesvendedor === false ? 0 : 1,
                    'todasfiliais'          : this.vtodasfiliais,
                    'diretorioimagem'       : this.vdiretorioimagem, 
                    'foto'                  : this.vfoto,
                    'cardresumopedidos'     : this.vcardresumopedidos === false ? 0 : 1,
                    'cardfinanceiro'        : this.vcardfinanceiro === false ? 0 : 1,
                    'cardrecursos'      : this.vcardrecursos === false ? 0 : 1,
                    'cardvendedores'        : this.vcardvendedores === false ? 0 : 1,     
                    'cardcompra'            : this.vcardcompra === false ? 0 : 1,                                     
                    'menu'                  : this.lstMenuUsuario,
                    'salesagent'            : this.vsalesagent === false ? 0 : 1,
                    'filiais'               : parseInt(this.vtodasfiliais) === 0 ? this.lstFiliais : [],
                    'tabelas'               : this.lsttabelasve
                };
                let parametros      = [
                    {parametro: 'idclientesac', valor  : vself.$store.state.filialpadrao.idcliente},
                    {parametro: 'diretorioimagens', valor : vself.$store.state.configpaths.pathimgusuarios+vself.$store.state.filialpadrao.idcliente},                    
                    {parametro: 'op',               valor : 'rotinacrud'},
                    {parametro: 'opcrud',           valor : vself.opcrud},
                    {parametro: 'registro',         valor : JSON.stringify(registrocrud)},
                    {parametro: 'idfilial',         valor : vself.$store.state.filialpadrao.codfil},
                    {parametro: 'idusuario',        valor : vself.$store.state.usuario.id},
                    {parametro: 'codop',            valor : parseInt(this.opcrud) === 1 ? '002Z.001L.001L' : parseInt(this.opcrud) === 2 ? '002Z.001L.002L' : '002Z.001L.003L'},
                    {parametro: 'idclisac',         valor : vself.$store.state.filialpadrao.idcliente}
                ];
                let retorno     = util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv+'/controller/rtcadusuarios.php');
                retorno.then(function (response) {
                    loader.hide();
                    if ($.isNumeric(response.data)){
                        vself.$toastr.s('Registro processado com sucesso!', 'Informação!');
                        vself.pfiltro       = 0;
                        vself.pativo        = 2;
                        vself.pconteudo     = parseInt(vself.opcrud) === 1 ? response.data : vself.vcodusu;
                        vself.pqtd_paginas  = 1;
                        vself.mtdcancelaredicao();
                        vself.mtdcarregausuarios(1);
                    }else{
                        let tpret = response.data.substring(0,1);
                        switch (tpret) {
                            case 'I':
                                vself.$toastr.w(response.data.substring(4), 'Atenção!');
                                break;
                            case 'E': default:
                                vself.$toastr.e(response.data.substring(4), 'Erro!');
                                break;
                        }
                    }
                }).catch(function (response) {
                    loader.hide();
                    vself.$toastr.e('Erro ao processar o registo. Descrição do erro: '+response.message, 'Erro!');
                });
            },
            mtdmonitoramento(){
                if (!util.opcaousuario('002Z.001L.006L', this.$store.state.perfilusuario)){
                    this.$toastr.i('Acesso não permitido para o usuário!', 'Informação!');
                }else {
                    this.itensbc.item2.titulo = 'MONITORAMENTO DE USUÁRIOS';
                    this.itensbc.item1.ativo = true;
                    this.itensbc.item2.ativo = true;
                    this.ativadesativa = false;
                    $('#pnlista').hide();
                    $('#pnmonitoratividades').fadeIn(700);
                }
            },
            mtdlistaratividadesusuar(){
                let vself = this;
                let rotina = '';
                if (vself.midrotina === null){
                    rotina = '';
                    // vself.$toastr.w('Rotina deve ser informada!', 'Informação!');
                    // $('#cbrotinamonitora').select2('open');
                }else{
                    rotina = vself.midrotina;
                }

                let loader      = vself.$loading.show();

                $("[data-toggle='tooltip']").tooltip('hide');
                vself.mfiltro                   = '';
                vself.lstatividades             = [];
                vself.lstetividadesencontradas  = [];

                let filtro = " and a.codop like '"+rotina+"%' and a.dthratividade between '" + 
                            util.InverterData(vself.mdtini) + " 00:00:00' and '" + 
                            util.InverterData(vself.mdtfim) + " 23:59:59'";

                if (vself.midusuario !== null) {
                    filtro = filtro+ " and a.idusuario=" + vself.midusuario;
                }
                if (vself.midfilial !== null) {
                    filtro = filtro+ " and a.idfilial=" + vself.midfilial;
                }
                
                let parametros      = [
                    {parametro: 'idclientesac', valor  : vself.$store.state.filialpadrao.idcliente},
                    {parametro: 'op',               valor : 'monitoramento'},
                    {parametro: 'filtro',           valor : filtro},
                    {parametro: 'ordem',            valor : vself.mordem},
                    {parametro: 'idfilial',         valor : vself.$store.state.filialpadrao.codfil},
                    {parametro: 'idusuario',        valor : vself.$store.state.usuario.id},
                    {parametro: 'codop',            valor : '002Z.001L.006L'},
                ];
                let retorno     = util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv+'/controller/rtcadusuarios.php');
                retorno.then(function (response) {
                    loader.hide();
                    vself.lstetividadesencontradas = response.data.lista;
                    vself.lstatividades = vself.lstetividadesencontradas;
                    setTimeout(function () {
                        $('[data-toggle="tooltip"]').tooltip();
                    },500);                    
                }).catch(function (response) {
                    loader.hide();
                    vself.$toastr.e('Erro ao processar a solicitação. Descrição do erro: '+response.message, 'Erro!');
                });                
            },
            mtddetalhesatividade() {
                if (this.lstdetalhes.length > 0) {
                    for (let i = 0; i < this.lstdetalhes.length; i++) {
                        this.mtdrenderizarjson('detjson' + i, this.lstdetalhes[i].conteudo);
                    }
                    $('#mdldetalhes').modal('show');
                }else{
                    vself.$toastr.s('Sem informações para análise!', 'Atenção');
                }
            },
            mtdrenderizarjson(dvexibir, conteudo){
                $('#'+dvexibir).html('');
                let data = conteudo;
                let target = '#'+dvexibir;
                jsonView.format(data, target);
            },            
            mtdadicionarjson(conteudojsonadd){
                if (!util.findValInArray(this.lstdetalhes,'id', conteudojsonadd.id)) {
                    let stranalizar = {
                        'id': conteudojsonadd.id,
                        'descricao': conteudojsonadd.descricao,
                        'conteudo': conteudojsonadd.detalhes
                    };
                    this.lstdetalhes.push(stranalizar);
                    this.$toastr.s('Detalhe adicionado para análise!', 'Informação!');
                }else{
                    this.$toastr.w('Atividade já adicionada para análise!', 'Atenção!');
                }
            },
            mtddelitemanalisar:function (indice) {
                this.lstdetalhes.splice(indice, 1);
                if (this.lstdetalhes.length < 1){
                    $('#mdldetalhes').modal('hide');
                }
            }            
        },
        mounted: function () {
            if (util.verificasessao(this)) {
                let vself = this;
                let loader = vself.$loading.show();
                let parametros = [
                    {parametro: 'op', valor: 'dadosusuario'},
                    {parametro: 'idclientesac', valor  : vself.$store.state.usuario.idclientesac},
                    {parametro: 'idusuario', valor: vself.$store.state.usuario.id}
                ];
                let retorno = util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv+'/controller/rotinasusuario.php');
                retorno.then(function (response) {
                    loader.hide();
                    vself.$store.commit('MUDAR_PERFIL_USUARIO', response.data.perfilusu);
                    if (util.opcaousuario('002Z.001L', vself.$store.state.perfilusuario)) {
                        vself.pathimgview           = vself.$store.state.configpaths.pathimagens;
                        vself.pathfotovisualizar    = vself.$store.state.configpaths.pathimagens,
                        $('#pnlista').fadeIn(700);
                        vself.mtdexecutapesquisa();
                        vself.mtdselect2_def();
                    } else {
                        vself.$toastr.i('Acesso não permitido para o usuário!', 'Informação!');
                        setTimeout(function(){
                            util.gotoprincipal();
                        },1000);
                    }
                }).catch(function (response) {
                    loader.hide();
                    console.log(response.message);
                });
            }
        },
        computed:{
            validou() {
                return this.vnomeusu === '' || this.vloginusu === '' || this.vsenhausu === '' || this.vemailusu === "" || this.vcodfil === null || this.vidgrupo === null || this.vidvendedor === null;
            }
        },
        watch:{
            pagina_atual(val){
                this.mtdcarregausuarios(val);
            },
            mfiltro(val){
                if (val.toUpperCase() !== ''){
                    this.lstatividades = $.grep(this.lstetividadesencontradas, function(element){
                        return element.descricao.toUpperCase().indexOf(val.toUpperCase()) !== -1;
                    });
                }else{
                    this.lstatividades = this.lstetividadesencontradas;
                }
            }            
        }
    }
</script>
<style>
    .def-col-cod{
        width: 80px !important;
    }
    #btclonarperfilusuario{
        cursor: pointer;
        font-weight: bold;
        font-size: 18px;
        position: relative;
        float: right;
        top: 5px;
        transition: .35s;
    }
    #btmarcartodosopusuario{
        font-weight: bold;
        font-size: 18px;
        padding-right: 10px;
        cursor: pointer;
        position: relative;
        float: right;
        top: 5px;
        transition: .35s;
    }
    #btmarcartodosopusuario:hover{
        color: #666666;
        transition: .35s;
    }
    #btmarcartodfiliais{
        font-weight: bold;
        font-size: 18px;
        padding-right: 10px;
        cursor: pointer;
        position: relative;
        float: right;
        top: 5px;
        transition: .35s;
    }
    #btmarcartodfiliais:hover{
        color: #666666;
        transition: .35s;
    }
    #btclonarperfilusuario:hover{
        color: #666666;
        transition: .35s;
    }
    .img-usuario{
        cursor: pointer;
        width: 150px !important;
        height: 155px !important;
    }
    .btn-del-imgusuario{
        position: absolute;
        top: 10px;
        left: 10px;
    }
    .titlabels{
        font-weight: 600!important;
        color: #666;
    }
    .titdata{
        font-size: 12px;
    }
    .titatividade{
        font-weight: 600!important;
    }
    .mimgusuario{
        position: relative;
        left: -2px;
        top: 0px;
        width: 30px;
        height: 30px;
        border: 1px solid #dedede;
        border-radius: 50%;
    }
</style>